<template>
	<UITopHeading>AGBs und Teilnahmebedingungen</UITopHeading>
	<div class="container flex flex-col">
		<SharedTheParticipation />
	</div>
</template>

<script setup lang="ts">
useSeoMeta({
	title: 'AGBs & Teilnahme',
	ogTitle: 'AGBs & Teilnahme',
	twitterTitle: 'AGBs & Teilnahme',
	description: 'Alle AGBs & Teilnahmebedingungen für das Propellerfestival.',
	ogDescription: 'Alle AGBs & Teilnahmebedingungen für das Propellerfestival.',
	twitterDescription:
		'Alle AGBs & Teilnahmebedingungen für das Propellerfestival.',
	ogUrl: 'https://propellerfestival.de/teilnahme',
})
</script>

<style scoped></style>
